import DonateButton from './donate_button'
import { connect } from 'react-redux'
import { glimpseRoute } from 'lib/route_utils'
import { loginUrlSelector, isLoggedInSelector } from 'redux/selectors/login'
import { getCampaignSelector } from 'redux/selectors/campaign'
import isOwnerSelector from 'redux/selectors/is_owner'
import hasCurrencyBalanceSelector from 'redux/selectors/has_currency_balance'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/send_glimpse/send_confirm')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  let donateHref = glimpseRoute('send')
  let fullPageRefresh = false
  const hasCurrencyBalance = hasCurrencyBalanceSelector(state, props)
  if (!isLoggedInSelector(state) && hasCurrencyBalance) {
    donateHref = window.location.origin + donateHref
    if (state.send_iframe.gs_bypass) {
      donateHref += '?gsbps=true'
    }

    const onboardData = {
      'country.x': state.country.country_code,
      'locale.x': state.country.locale,
      intent: 'tesla',
      redirect_url: donateHref,
      sendMoneyText: i18n('title', {
        name: campaign.owner.business_name || campaign.owner.full_name,
      }),
    }
    const options = {
      returnUri: donateHref,
      onboardData: `onboardData=${encodeURIComponent(
        JSON.stringify(onboardData)
      )}`,
      showGuest: state.can_guest,
    }
    donateHref = loginUrlSelector(options)(state)
    fullPageRefresh = true
  }
  const isOwner = isOwnerSelector(state, props)
  return {
    preview: campaign.preview,
    canChipIn: campaign.can_chip_in,
    canDonate: campaign.can_donate,
    noCurrencyBalance: isOwner && !hasCurrencyBalance,
    isOwner,
    endDate: campaign.end_date,
    donateHref,
    fullPageRefresh,
  }
}
export default connect(mapStateToProps)(DonateButton)
